module.exports = __webpack_public_path__ + "static/media/OctetLogoWhite.0b1af7e8.png";